import licenseModule from '../../license.module';

licenseModule.component('licenseBilling', {
    template: require('./licenseBilling.component.html'),
    controller: licenseBillingComponent,
    bindToController: true,
    bindings: {
        billingContactInformation: '<'
    }
});

function licenseBillingComponent(asLoadingMask) {
    var vm = this;

    vm.$onChanges = change;

    vm.billingContactInformation = {
        name: '',
        phone: '',
        address: '',
        email: '',
        aan: ''
    };

    asLoadingMask.show();

    function change(changeObj) {
        if (
            changeObj.billingContactInformation.currentValue &&
            changeObj.billingContactInformation.currentValue != null
        ) {
            asLoadingMask.hide();
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-billing/licenseBilling.component.js